import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import useTranslation from '../../../../Hooks/useTranslation';
import NoEscape from '../../../../Components/NoEscape';

// @ts-ignore
import styles from './CommercialCertificateHint.module.scss';

const CommercialCertificateHint: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<NoEscape>{t('component.certificates.commerce.hint.text1')}</NoEscape>
			<Text tx='component.certificates.commerce.hint.text2' />
			<ul>
				<li>{t('component.certificates.commerce.hint.list.item1')}</li>
				<li>{t('component.certificates.commerce.hint.list.item2')}</li>
			</ul>
			<div>
				{t('component.certificates.commerce.hint.text3')}{' '}
				<a
					target='_blank'
					href='https://www.vzp.cz/e-vzp/b2b-komunikace/podporovane-certifikaty'>
					https://www.vzp.cz/e-vzp/b2b-komunikace/podporovane-certifikaty
				</a>
			</div>
		</div>
	);
};

export default CommercialCertificateHint;
